<template>
  <form v-on:submit.prevent="submit">
    <RFormSection :title="$t('blockator.subtitle1')">
      <RFormField>
        <RFieldLabel :isError="fields.email.error">{{
          fields.email.label
        }}</RFieldLabel>
        <input
          type="text"
          v-model="fields.email.value"
          class="container-full"
          :class="{ error: fields.email.error }"
        />
      </RFormField>
    </RFormSection>
    <RFormSection :title="$t('blockator.subtitle2')">
      <RFormField>
        <RFieldLabel :isError="fields.manufacturer.error">{{
          fields.manufacturer.label
        }}</RFieldLabel>
        <input
          type="text"
          v-model="fields.manufacturer.value"
          class="container-full"
          :class="{ error: fields.manufacturer.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.production_date.error">{{
          fields.production_date.label
        }}</RFieldLabel>
        <flat-pickr
          v-model="fields.production_date.value"
          :config="fields.production_date.config"
          class="flatpickr"
          :class="{ error: fields.production_date.error }"
        ></flat-pickr>
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.batch.error">{{
          fields.batch.label
        }}</RFieldLabel>
        <select
          v-model="fields.batch.value"
          class="container-full"
          :class="{ error: fields.batch.error }"
        >
          <option disabled value>Выберите один из вариантов</option>
          <option value="1">1</option>
          <option value="2">2</option>
        </select>
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.expert.error">{{
          fields.expert.label
        }}</RFieldLabel>
        <select
          v-model="fields.expert.value"
          class="container-full"
          :class="{ error: fields.expert.error }"
        >
          <option disabled value>Выберите один из вариантов</option>
          <option value="1">1</option>
          <option value="2">2</option>
        </select>
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.protocol.error">{{
          fields.protocol.label
        }}</RFieldLabel>
        <input
          type="text"
          v-model="fields.protocol.value"
          class="container-full"
          :class="{ error: fields.protocol.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.concentration.error">{{
          fields.concentration.label
        }}</RFieldLabel>
        <input
          type="text"
          v-model="fields.concentration.value"
          class="container-full"
          :class="{ error: fields.concentration.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.deviation.error">{{
          fields.deviation.label
        }}</RFieldLabel>
        <input
          type="text"
          v-model="fields.deviation.value"
          class="container-full"
          :class="{ error: fields.deviation.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.images.error">{{
          fields.images.label
        }}</RFieldLabel>
        <file-pond
          name="images"
          ref="pond"
          allow-multiple="true"
          accepted-file-types="image/jpeg, image/png"
          :label-idle="$t('blockator.dragImages')"
          v-bind:server="upload"
          v-on:init="handleFilePondInit"
          v-on:removefile="removefile"
        />
      </RFormField>
    </RFormSection>
  </form>
</template>

<script>
import robonomicsVC from "robonomics-vc";
import vueFilePond from "vue-filepond";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";
import "filepond/dist/filepond.min.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.min.css";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";

const FilePond = vueFilePond(FilePondPluginFileEncode);

export default {
  mixins: [robonomicsVC.mixins.form],
  components: {
    FilePond,
    flatPickr,
  },
  data() {
    return {
      upload: {
        process: (fieldName, file, metadata, load, error, progress, abort) => {
          if (
            Object.prototype.hasOwnProperty.call(this.fields, fieldName) &&
            Object.prototype.hasOwnProperty.call(
              this.fields[fieldName],
              "value"
            )
          ) {
            this.fields[fieldName].value = file;
          } else {
            this.fields[fieldName].items[file.name] = file;
          }
          load();
          return {
            abort: () => {
              abort();
            },
          };
        },
        revert: null,
      },
      fields: {
        email: {
          label: this.$t("blockator.fields.email"),
          value: "",
          type: "text",
          rules: [
            function(v) {
              return (
                !robonomicsVC.validators.require(v) || /\S+@\S+\.\S+/.test(v)
              );
            },
          ],
          error: false,
        },
        manufacturer: {
          label: this.$t("blockator.fields.manufacturer"),
          value: "",
          type: "text",
          rules: ["require"],
          error: false,
        },
        production_date: {
          label: this.$t("blockator.fields.production_date"),
          value: new Date().getMonth() + 1 + "." + new Date().getFullYear(),
          type: "datepicker",
          rules: ["require"],
          error: false,
          config: {
            locale: Russian,
            plugins: [
              new monthSelectPlugin({
                dateFormat: "m.Y",
              }),
            ],
          },
        },
        batch: {
          label: this.$t("blockator.fields.batch"),
          value: "",
          type: "text",
          rules: ["require"],
          error: false,
        },
        expert: {
          label: this.$t("blockator.fields.expert"),
          value: "",
          type: "text",
          rules: ["require"],
          error: false,
        },
        protocol: {
          label: this.$t("blockator.fields.protocol"),
          value: "",
          type: "text",
          rules: ["require"],
          error: false,
        },
        concentration: {
          label: this.$t("blockator.fields.concentration"),
          value: "",
          type: "text",
          rules: ["require"],
          error: false,
        },
        deviation: {
          label: this.$t("blockator.fields.deviation"),
          value: "",
          type: "text",
          rules: ["require"],
          error: false,
        },
        images: {
          label: this.$t("blockator.fields.images"),
          items: {},
          type: "files",
          rules: [],
          error: false,
        },
      },
    };
  },
  methods: {
    handleFilePondInit() {
      console.log("FilePond has initialized");
    },
    removefile(a, file) {
      if (this.fields.images.items[file.filename]) {
        delete this.fields.images.items[file.filename];
      }
    },
  },
};
</script>

<style>
.theme-light [data-filepond-item-state="processing-complete"] .filepond--file {
  color: white;
}
</style>
